var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrenght(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.9744L22.6667 10.6667M16 12.9744L9.33333 10.6667M16 12.9744V22.6667M22.6667 4H25.3333C26.8061 4 28 5.19391 28 6.66667V9.33333M22.6667 28H25.3333C26.8061 28 28 26.8061 28 25.3333V22.6667M9.33333 4H6.66667C5.19391 4 4 5.19391 4 6.66667V9.33333M9.33333 28H6.66667C5.19391 28 4 26.8061 4 25.3333V22.6667M16.8648 8.29652L22.1981 10.1251C23.276 10.4946 24 11.5082 24 12.6476V18.6299C24 19.6735 23.3912 20.6212 22.442 21.0551L17.1087 23.4932C16.4047 23.8151 15.5953 23.8151 14.8913 23.4932L9.55797 21.0551C8.60881 20.6212 8 19.6735 8 18.6299V12.6476C8 11.5082 8.72396 10.4946 9.8018 10.1251L15.1352 8.29652C15.6957 8.10433 16.3043 8.10433 16.8648 8.29652Z",
    stroke: "#126DC8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrenght);
export default __webpack_public_path__ + "static/media/strenght.200480321de0d83be2555f6d07557497.svg";
export { ForwardRef as ReactComponent };